exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*Font Style Convertion*/\n/*Main Slide height*/\n/*Product icon block*/\n/*Default Content width*/", ""]);

// exports
